<!-- @veltra/icons generated sha256:971876d7ee2c9d58 gen:8 source:src/svg/normal/maximum.svg -->
<script setup lang="ts">
defineOptions({ name: 'Maximum' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M3.5 4.207V7h-1V2.995c0-.276.22-.495.495-.495H7v1H4.207l3.147 3.146-.708.708zm9 7.586V9h1v4.005c0 .276-.22.495-.495.495H9v-1h2.793L8.646 9.354l.708-.708z"
    />
  </svg>
</template>
